import { ColumnExtended } from './ColumnExtended';
import { CheckmarkCircleFilled, ErrorCircleFilled, ArrowSyncFilled, WarningFilled, ProhibitedFilled, StackFilled, SendFilled } from '@fluentui/react-icons';


const DASHBOARD_MIN_COLUMN_WIDTH = 60;

export const DashboardColumns: ColumnExtended[] = [
    {
        key: 'documentNumber',
        name: 'Document Number',
        fieldName: 'documentId',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH * 1.5,
    },
    {
        key: 'documentType',
        name: 'Document Type',
        fieldName: 'documentType',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH * 1.2,
    },
    {
        key: 'country',
        name: 'Country',
        fieldName: 'countryCode',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH,
    },
    {
        key: 'company',
        name: 'Company Code',
        fieldName: 'companyCode',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH,
    },
    {
        key: 'partner',
        name: 'Calling Service',
        fieldName: 'eInvPartnerId',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH * 1.5
    },
    {
        key: 'receivedTime',
        name: 'Received Time',
        fieldName: 'startEventTime',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH * 1.5,
        isSorted: true,
        isSortedDescending: true,
        isSortable: true

    },
    {
        key: 'completedTime',
        name: 'Completed Time',
        fieldName: 'endEventTime',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH * 1.5,
        isSortable: true
    },
    {
        key: 'status',
        name: 'Status',
        fieldName: 'status',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH * 0.8,
        onRender: (item) => {
            if (item.status === 'Failed')
                return <ErrorCircleFilled style={{ color: 'red' }} />;
            else if (item.status === 'Succeeded')
                return <CheckmarkCircleFilled style={{ color: 'green' }} />;
            else if (item.status === 'In Progress')
                return <ArrowSyncFilled style={{ color: 'blue' }} />;
            else if (item.status === 'Warning')
                return <WarningFilled style={{ color: 'orange' }} />;
            else if (item.status === 'Cancel Succeeded')
                return <ProhibitedFilled style={{ color: 'green' }} />;
            else if (item.status === 'Cancel Failed')
                return <ProhibitedFilled style={{ color: 'red' }} />;
            else if (item.status === 'Cancel In Progress')
                return <ProhibitedFilled style={{ color: 'blue' }} />;
            else if (item.status === 'Batched')
                return <StackFilled style={{ color: '#986F0B' }} />;
            else if (item.status === 'Sent')
                return <SendFilled style={{ color: '#4F6BED' }} />;
            return null;
        }
    },
    {
        key: 'extReceiptId',
        name: 'Ext. Receipt Id',
        fieldName: 'extReceiptId',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH * 2.5,
    },
    {
        key: 'internalInvoiceNumber',
        name: 'Internal Invoice Number',
        fieldName: 'invoiceNumber',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH * 1.5,
    },
    {
        key: 'supplier',
        name: 'Supplier',
        fieldName: 'supplier',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH,
    },
    {
        key: 'scenario',
        name: 'Scenario',
        fieldName: 'scenario',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH
    },
    {
        key: 'channel',
        name: 'Channel',
        fieldName: 'channel',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH
    },
    {
        key: 'salesMotion',
        name: 'Sales Motion',
        fieldName: 'salesMotion',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH
    },
    {
        key: 'documentGenerationDate',
        name: 'DocumentGenerationDate',
        fieldName: 'documentGenerationDate',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH * 1.5
    },
    {
        key: 'errorCode',
        name: 'Error Code',
        fieldName: 'errorCode',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH,
    },
    {
        key: 'paymentType',
        name: 'Payment Type',
        fieldName: 'paymentType',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH,
        isVisible: ['INT', 'DEV', 'TEST'].includes(process.env.REACT_APP_EINVOICING_ENVIRONMENT ?? '')
    },
    {
        key: 'invoiceTotal',
        name: 'Amount',
        fieldName: 'invoiceAmount',
        isResizable: true,
        minWidth: 120,
        isVisible: ['INT', 'DEV', 'TEST'].includes(process.env.REACT_APP_EINVOICING_ENVIRONMENT ?? ''),
        onRender: (item) => {
            if (item.invoiceAmount && item.invoiceCurrency) {
                return `${item.invoiceAmount} ${item.invoiceCurrency}`;
            }
            return item.invoiceAmount ?? '';
        }
    },
    {
        key: 'mode',
        name: 'Mode',
        fieldName: 'mode',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH
    },
    {
        key: 'numberOfSubmissions',
        name: 'Number of Submissions',
        fieldName: 'numberOfSubmissions',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH
    }
]
